import {DomainError} from '@s-ui/domain'

export class GetMatchesUserAlertsError extends DomainError {
  #cause
  #code
  #message

  static GENERIC_ERROR_CODE = 'generic_get_matches_user_alerts_error'
  static INVALID_PARAMETERS_ERROR_CODE = 'invalid_parameters_get_matches_user_alerts_error'
  static NOT_AUTHENTICATED_ERROR_CODE = 'not_authenticated_get_matches_user_alerts_error'
  static NOT_AUTHORIZED_ERROR_CODE = 'not_authorized_get_matches_user_alerts_error'
  static SAVED_SEARCH_NOT_FOUND_ERROR_CODE = 'saved_search_not_found_get_matches_user_alerts_error'

  constructor({cause, code, message}) {
    super({cause, code, message})
    this.#cause = cause
    this.#code = code
    this.#message = message
  }

  static isGetMatchesUserAlertsError({error}) {
    return error instanceof GetMatchesUserAlertsError
  }

  static create({code, message, cause}) {
    return new GetMatchesUserAlertsError({code, message, cause})
  }

  static createGenericError({cause}) {
    return GetMatchesUserAlertsError.create({
      code: GetMatchesUserAlertsError.GENERIC_ERROR_CODE,
      cause,
      message: 'ERRORS.GET_MATCHES_USER_ALERTS.GENERIC'
    })
  }

  static createInvalidParametersError() {
    return GetMatchesUserAlertsError.create({
      code: GetMatchesUserAlertsError.INVALID_PARAMETERS_ERROR_CODE,
      message: 'ERRORS.GET_MATCHES_USER_ALERTS.INVALID_PARAMETERS'
    })
  }

  static createNotAuthenticatedError() {
    return GetMatchesUserAlertsError.create({
      code: GetMatchesUserAlertsError.NOT_AUTHENTICATED_ERROR_CODE,
      message: 'ERRORS.GET_MATCHES_USER_ALERTS.NOT_AUTHENTICATED'
    })
  }

  static createNotAuthorizedError() {
    return GetMatchesUserAlertsError.create({
      code: GetMatchesUserAlertsError.NOT_AUTHORIZED_ERROR_CODE,
      message: 'ERRORS.GET_MATCHES_USER_ALERTS.NOT_AUTHORIZED'
    })
  }

  static createSavedSearchNotFoundError() {
    return GetMatchesUserAlertsError.create({
      code: GetMatchesUserAlertsError.SAVED_SEARCH_NOT_FOUND_ERROR_CODE,
      message: 'ERRORS.GET_MATCHES_USER_ALERTS.SAVED_SEARCH_NOT_FOUND'
    })
  }

  get value() {
    return {
      code: this.#code,
      message: this.message,
      cause: this.cause
    }
  }

  isGenericError() {
    return this.#code === GetMatchesUserAlertsError.GENERIC_ERROR_CODE
  }

  isInvalidParametersError() {
    return this.#code === GetMatchesUserAlertsError.INVALID_PARAMETERS_ERROR_CODE
  }

  isNotAuthenticatedError() {
    return this.#code === GetMatchesUserAlertsError.NOT_AUTHENTICATED_ERROR_CODE
  }

  isNotAuthorizedError() {
    return this.#code === GetMatchesUserAlertsError.NOT_AUTHORIZED_ERROR_CODE
  }

  isSavedSearchNotFoundError() {
    return this.#code === GetMatchesUserAlertsError.SAVED_SEARCH_NOT_FOUND_ERROR_CODE
  }

  isGetMatchesUserAlertsError() {
    return true
  }

  toJSON() {
    return {
      code: this.#code,
      message: this.#message,
      cause: this.#cause
    }
  }
}
